import {TransformBase} from "../TranformBase";

import {AssistantReminderRecordModel} from "@/api/models/assistants/reminders";
import {Assistant} from "@/api/services";

export class AssistantRemindersTransform extends TransformBase {
  public makeCompactModel(dto: Assistant): AssistantReminderRecordModel {
    const model: AssistantReminderRecordModel = {
      isEnabled: dto.send_user_idle_reminder,
      message: dto.reminder_message,
      afterIdleSeconds: dto.reminder_after_idle_seconds,
    };

    return model;
  }
}

export const assistantRemindersTransform = new AssistantRemindersTransform();
